<template>
  <AutoComplete
    :suggestions="filteredPoNumber"
    @complete="search($event)"
    :dropdown="true"
    field="po_number"
    v-model="po_number"
    forceSelection
  >
    <template #item="slotProp">
      {{ slotProp.item.po_number }}
    </template>
  </AutoComplete>
</template>

<script setup>
import { onMounted, ref, defineEmits, watchEffect } from "vue";
import receiptService from "../../../service/ReceiptService";

const filteredPoNumber = ref([]);
const poNumberList = ref([]);
const poNumber = ref();
// const placeholder = ref("Select a Batch Number");

const emit = defineEmits(["poNumber"]);
watchEffect(() => emit("poNumber", poNumber));

// eslint-disable-next-line no-undef
const props = defineProps({
  company: {
    type: Object,
  },
  vendorId: {
    type: Object,
  },
  levelTenant: {
    type: String,
  },
});

onMounted(async () => {
  try {
    // 
    if (props.company && props.vendorId && props.levelTenant) {
      const result = await receiptService.getlistponumber(
        props.vendorId,
        props.company.db_instance,
        props.company.value,
        props.levelTenant
      );
      
      poNumberList.value = result.data;
    }

    // eslint-disable-next-line no-empty
  } catch (e) {
    throw new Error(e);
  }
});

const search = (event) => {
  setTimeout(() => {
    if (!event.query.trim().length) {
      filteredPoNumber.value = [...poNumberList.value];
    } else {
      filteredPoNumber.value = poNumberList.value.filter((poNum) => {
        
        return poNum.po_number
          .toLowerCase()
          .match(event.query.toLowerCase());
      });
    }
  }, 250);
};
</script>
